import axios from 'axios';

export let headers = {
  'Tenant-Access-Token': 'ZjQ1MzliZmUyYTcyNDE0ZmY5YzcyNTY5ZThlZTEyNGM=',
  'Tenant-Access-Key': '33vRu9qiutSCdg',
};

export const api = axios.create({
  baseURL: 'https://tiltlabs-dev.confirmu.com',
  headers: {
    'Tenant-Access-Token': 'ZjQ1MzliZmUyYTcyNDE0ZmY5YzcyNTY5ZThlZTEyNGM=',
    'Tenant-Access-Key': '33vRu9qiutSCdg',
  },
});

export const BASE_URL = 'https://tiltlabs-dev.confirmu.com';
